import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LayoutState {
  theme: 'dark' | 'light';
  layout: 'grid' | 'list';
  sidebarOpen: boolean;
  mobileMenuOpen: boolean;
}

const initialState: LayoutState = {
  theme: 'dark',
  layout: 'grid',
  sidebarOpen: false,
  mobileMenuOpen: false,
};

const layoutSlice = createSlice({
  name: 'layout',
  initialState,
  reducers: {
    toggleTheme: (state) => {
      state.theme = state.theme === 'dark' ? 'light' : 'dark';
    },
    setLayout: (state, action: PayloadAction<'grid' | 'list'>) => {
      state.layout = action.payload;
    },
    toggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen;
    },
    toggleMobileMenu: (state) => {
      state.mobileMenuOpen = !state.mobileMenuOpen;
    },
    closeMobileMenu: (state) => {
      state.mobileMenuOpen = false;
    },
  },
});

export const { 
  toggleTheme, 
  setLayout, 
  toggleSidebar, 
  toggleMobileMenu,
  closeMobileMenu
} = layoutSlice.actions;

export default layoutSlice.reducer; 